import { useStyletron } from 'baseui';
import { Theme } from 'baseui/theme';

export const useThemeContext = (): Theme => {
  return useStyletron()[1];
};
